export default {
	DEADLINE_INGEDIEND: 'INGEDIEND',
	DEADLINE_VERZONDEN: 'VERZONDEN'
};
